<template>
  <div id="result">
    <div class="success-icon-wrapper">
      <img :src="successImage" alt="" />
    </div>
    <!-- <div class="tooltip">恭喜您获得bimmake软件使用权</div> -->
    <div class="infomation" v-if="$route.query.type == '2'">
      {{ infomation
      }}<a @click="skip" class="href-wrapper">点此了解旗舰版与基础版功能区别</a>
    </div>
    <div class="infomation" v-else>
      账号已到期，购买产品即可继续使用软件，祝您使用愉快
    </div>
    <div class="cart-wrapper">
      <div class="left-cart cart">
        <div class="title-wrapper">
          <span class="title">购买</span>
        </div>
        <div class="content">
          <div class="pay">点击立即购买，<br/>购买产品云授权</div>
          <!-- <div class="price-wrapper">
            <span class="icon">￥</span>
            <span class="price">780</span>
            <span class="month">元/月</span>
          </div> -->
        </div>
        <!-- <div class="button-wrapper" @click="skipUpgrade">立即购买</div> -->
        <div class="button-wrapper" @click="skipBuyPage">立即购买</div>
      </div>
      <div class="right-cart cart">
        <div class="title-wrapper">
          <span class="title">授权</span>
        </div>
        <div class="content">
          <div class="pay" v-if="freeMethod"> 新用户有一次试用授权，点击下方按钮立即授权</div>
          <div class="pay" v-else> 免费授权已经使用<br/>
            <!-- 无需授权 -->
          </div>
          <!-- <div class="price-wrapper">
            <span class="icon">￥</span>
            <span class="price">249</span>
            <span class="month">元/月</span>
          </div> -->
          <!-- <div class="year">2980元/年</div> -->
        </div>
        <div v-if="freeMethod" class="button-wrapper" @click="handleAuthorization">立即授权</div>
        <div v-else class="button-wrapper disabled-btn">立即授权</div>
      </div>
    </div>
    <div v-if="$route.query.type == '3'" @click="skip" class="bottomTootip">
      <a>点此了解旗舰版与基础版功能区别</a>
    </div>
    <!-- <div class="close" @click="windowClose">关闭</div> -->
  </div>
</template>

<script>
import successImage from "@/assets/images/success.png";
import UserEnterpriseApi from "@/api/userEnterpriseApi.js";
import { skipNewPage } from '@/utils/utils'
import {
  message
} from "ant-design-vue";
// import maiFn from "@/utils/maidian";
export default {
  data() {
    return {
      successImage,
      infomation: "恭喜您已注册成功",
      text: "使用权，软件中内置有学习视频，祝您使用愉快",
      freeMethod: false
    };
  },
  create() {
    // if (this.$route.query.type === "2") {
    //   this.infomation = "恭喜您已注册成功获得360天基础版免费使用权";
    // } else if (this.$route.query.type === "3") {
    //   this.infomation = "恭喜您已注册成功";
    // }
  },
  created() {
    // UserEnterpriseApi.getAuth().then(res => {
    //   console.log('[ res ] >', res)
    // })
  },
  mounted() {
    const { getAuth } = UserEnterpriseApi;
    getAuth().then(res => {
      if (res.status) {
        this.freeMethod = res.data.freeMethod
      } else {
        message.error(res.msg);
      }
    })
    // maiFn(sgyToken, globalId, version, "show", this, "结果页展示", source);
  },
  methods: {
    windowClose() {
      window.location.href = "about:blank";
      window.close();
      // window.open('about:blank', '_top').close()
    },

    /**
     * @Description: 跳转
     * @param {*}
     * @Date: 2022-04-27 17:38:45
     */
    skip() {
      // window.location.href = 'https://b.zpert.com/upload/client_home/buy.html'
      window.open(
        "https://shop.glodon.com/goodsDetail?skuId=1518054547998203906&goodsId=1517411275490340866",
        "_blank"
      );
    },

    /**
     * @Description: 跳转购买页面
     * @Date: 2022-12-15 13:40:01
     * 基础版 https://qr32.cn/CyQP7o
     * 旗舰版：https://qr32.cn/AHQVmk
     * 翻样版：https://qr32.cn/C6yFsQ
     */
    skipBuyPage() {
      const { source } = UserEnterpriseApi
      if (source === 'BIMMAKE2520') { // 基础版
        skipNewPage('https://qr32.cn/CyQP7o')
      } else if (source === 'BIMMAKE3330') { // BIMMAKE翻样版;
        skipNewPage('https://qr32.cn/C6yFsQ')
      } else if (source === 'BIMMAKE3331') { // BIMMAKE旗舰版
        skipNewPage('https://qr32.cn/AHQVmk')
      }
    },

    /**
     * @Description: 跳转
     * @param {*}
     * @Date: 2022-04-27 17:38:45
     */
    skipUpgrade() {
      if (window.webObject && window.webObject.loadUrlInBrowser) {
        window?.webObject?.loadUrlInBrowser('https://shop.glodon.com/goodsDetail?skuId=1518054547817848834&goodsId=1517411275490340866')
      } else {
        window.open(
          "https://shop.glodon.com/goodsDetail?skuId=1518054547817848834&goodsId=1517411275490340866",
          "_blank"
        );
      }
    },
    /**
     * @Description: 跳转
     * @param {*}
     * @Date: 2022-04-27 17:38:45
     */
    skipBasic() {
      alert('测试使用')
      // window.open(
      //   "https://shop.glodon.com/goodsDetail?skuId=1518054547998203906&goodsId=1517411275490340866",
      //   "_blank"
      // );
    },

    handleAuthorization() {
      UserEnterpriseApi.authorization().then(res => {
        if (res.status) {
          message.success('授权成功！')
          if (window.webObject && window.webObject.pleaseAfreshLogin) {
            window.webObject.pleaseAfreshLogin(true)
          }
        } else {
          message.error(res.msg)
          if (window.webObject && window.webObject.pleaseAfreshLogin) {
            window.webObject.pleaseAfreshLogin(false)
          }
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
#result {
  padding-top: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .success-icon-wrapper {
    width: 234px;
    height: 139.87px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tooltip {
    margin-top: 18px;
    // width: 496px;
    height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 41px;
    color: #3c5055;
    opacity: 1;
  }
  .infomation {
    margin-top: 23px;
    // width: 561px;
    height: 17px;
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 26px;
    opacity: 1;
    .href-wrapper {
      color: #438afe;
      // text-decoration: underline;
    }
  }
  .cart-wrapper {
    margin-top: 40px;
    display: flex;
    .left-cart {
      margin-right: 15px;
      $color: #438afe;
      background: $color;
      .pay {
        color: $color;
      }
      .button-wrapper {
        background-color: #438afe;
        cursor: pointer;
      }
      .content {
        .price-wrapper {
          .icon {
            color: $color;
          }
          .price {
            color: $color;
          }
          .month {
            color: $color;
          }
        }
      }
    }
    .right-cart {
      background-color: #f6b440;
      .pay {
        color: #f6b440;
      }
      .button-wrapper {
        background-color: #f6b440;
        cursor: pointer;
      }
      .disabled-btn {
        color: #fff;
        background-color: #f3d19e;
        border-color: #f3d19e;
        // background-color: rgb(233, 197, 135);
        cursor: no-drop;
      }
      .content {
        .price-wrapper {
          .icon {
            color: #f6b440;
          }
          .price {
            color: #f67240;
          }
          .month {
            color: #f6b440;
          }
        }
        .year {
          font-size: 13px;
          font-family: Montserrat-Bold;
          line-height: 16px;
          color: #f6b440;
          opacity: 0.87;
        }
      }
    }
    .cart {
      width: 237px;
      height: 253px;
      opacity: 1;
      border-radius: 14px;
      // overflow: hidden;
      padding: 4px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: relative;
      .title-wrapper {
        height: 58px;
        height: 58px;
        opacity: 1;
        .title {
          font-size: 19px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 33px;
          color: #ffffff;
          opacity: 1;
          line-height: 58px;
        }
      }
      .content {
        flex: 1;
        background-color: #fff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        .pay {
          margin: 18px 0 24px 0;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 34px;
          opacity: 1;
        }
        .price-wrapper {
          .icon {
            font-size: 30px;
            margin-right: 12px;
          }
          .price {
            font-size: 37px;
            font-family: Montserrat-Bold;
            line-height: 45px;
            opacity: 1;
            margin-right: 6px;
          }
          .month {
            font-size: 12px;
            font-family: PingFangSC-Medium;
            line-height: 16px;
            opacity: 1;
          }
        }
      }
      .button-wrapper {
        position: absolute;
        left: 50%;
        margin-left: -77px;
        bottom: -23px;
        width: 154px;
        height: 46px;
        opacity: 1;
        border-radius: 29px;
        line-height: 46px;
        text-align: center;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        // line-height: 24px;
        color: #ffffff;
        // opacity: 0;
        z-index: 2;
      }
    }
  }

  .bottomTootip {
    margin-top: 50px;
    font-size: 16px;
    font-weight: bold;
    font-family: Source Han Sans CN;
    font-weight: 300;
    line-height: 24px;
    color: #838aa0;
    opacity: 1;
    cursor: pointer;
  }

  .close {
    background-color: #438afe;
    margin-top: 53px;
    width: 154px;
    height: 46px;
    border-radius: 29px;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    cursor: pointer;
  }
}
</style>
